
<template>
  <div class="system-notice">
    <div class="top-title tab-title">公告编辑</div>
    <!-- <Card dis-hover> -->
    <redtaiTab :list="tablist" v-model="tabname" />
    <!-- <ul class="common-search li-margin">
      <li>
        <span>公告标题: </span>
        <Input
          v-model="dataForm.title"
          @on-search="(e) => searchInput(e, 'title')"
          search
          placeholder="请输入"
        />
      </li>
      <li>
        <span>公告内容: </span>
        <Input
          v-model="dataForm.content"
          @on-search="(e) => searchInput(e, 'content')"
          search
          placeholder="请输入"
        />
      </li>

      <li class="dataPicker">
        <span>创建时间: </span>
        <DatePicker
          @on-change="(e) => changeDate(e, 'date')"
          v-model="dataForm.date"
          type="daterange"
          format="yyyy-MM-dd"
          placeholder="请选择"
          :clearable="false"
        />
      </li>
      <li class="dataPicker">
        <span>上线时间: </span>
        <DatePicker
          @on-change="(e) => changeDate(e, 'dates')"
          v-model="dataForm.dates"
          type="daterange"
          format="yyyy-MM-dd"
          placeholder="请选择"
          :clearable="false"
        />
      </li>
      <li class="searchItem">
        <Button class="sels-item" @click="resetData">重置</Button>
      </li>
    </ul> -->
    <div class="common-selects selected-margin" v-if="selItems.length">
      <span class="tit">已选:</span>
      <span class="sel" v-for="(item, index) in selItems" :key="index"
        >{{ item.val }}
        <Icon @click="delSelItem(item, index)" type="md-close-circle" />
      </span>
    </div>
    <div class="lists clearfix list-margin">
      <Button type="primary" @click="addNotice()">
        <Icon type="md-add" /> 新增公告
      </Button>
      <div class="common-list table-margin">
        <Table
          class="equipmentTable"
          :columns="cdataColumn"
          :data="dataLists"
        ></Table>
      </div>
      <div class="common-page fr" v-if="pageInfo.total">
        <Page
          show-total
          show-elevator
          show-sizer
          :total="pageInfo.total"
          :current="pageInfo.current"
          :page-size="pageInfo.size"
          @on-change="getLists"
          @on-page-size-change="changeSize"
        ></Page>
      </div>
    </div>
    <!-- </Card> -->
    <NoticeDrawer
      ref="noticeDrawer"
      :showlistDrawer="showlistDrawer"
      :closeDrawer="closeDrawer"
      :getLists="getLists"
      :propForm="propForm"
    ></NoticeDrawer>
        <NewsModal v-model="ismodel"  :curItemDetail="curItemDetail" />
  </div>
</template>

<script>
import api from "@/api";
import ls from "store2";
import deepcopy from "deepcopy";
import handleSelItem from "@/mixins/handleSelItem";
import NoticeDrawer from "./components/notice-drawer.vue";
import sizeData from "@/mixins/sizeData";
import redtaiTab from "@/components/redtai-tab/index.vue";
import { notelist, notpublish, notptoptop } from "@/api/system/notice";
import { mapState } from "vuex";
import truncationModul from "@/components/truncationModul/index";
import NewsModal from "@/components/news-modal.vue";
export default {
  name: "system-notice",
  mixins: [handleSelItem, sizeData],
  components: {
    NoticeDrawer,
    redtaiTab,
    truncationModul,
    NewsModal
  },
  watch: {
    tabname(newvalue, oldvalue) {
      if (newvalue !== oldvalue) {
        // if( newvalue.index==0){
        //   this.cdataColumn=this.dataColumn
        // }else{

        // }
        if (newvalue.index == 2) {
          let findIndex = this.dataColumn.findIndex(
            (e) => e.key == "failureTime"
          );
          let item = this.dataColumn[findIndex];
          item.title = "实际下线时间";
          this.$set(this.dataColumn, findIndex, item);
        } else {
          let findIndex = this.dataColumn.findIndex(
            (e) => e.key == "failureTime"
          );
          let item = this.dataColumn[findIndex];
          item.title = "下线时间";
          this.$set(this.dataColumn, findIndex, item);
        }
        this.pageInfo = {
          size: 10,
          current: 1,
          total: 0,
          status: newvalue.index,
        };
        this.$nextTick(() => {
          this.getLists();
        });
      }
    },
  },

  data() {
    return {
      ismodel:false,
      timer: null,
      propForm: {},
      tablist: ["待上线", "已上线", "已下线"],
      tabname: {
        index: 0,
        string: "待上线",
      },
      dataLists: [],
      selItems: [],
      dataForm: {},
      pageInfo: {
        size: 10,
        current: 1,
        total: 0,
        status: 0,
      },
      showlistDrawer: false,
      curItemDetail: {},
      cdataColumn: [],

      dataColumn: [
        {
          title: "序号",
          type: "index",
          width: 80,
          //  fixed: 'left',
        },
        {
          title: "公告标题",
          key: "title",

          render: (h, params) => {
            const item = params.row;
            return h("div", item.title || "-");
          },
        },
        // {
        //   title: "公告内容",
        //   key: "content",
        //   render: (h, params) => {
        //     const item = params.row;
        //     return h(truncationModul, {
        //       props: {
        //         text: item.content,
        //       },
        //     });
        //   },
        // },
        {
          title: "发布类型",
          key: "gmtCreate",
          width: 150,
          render: (h, params) => {
            const item = params.row;
            let arr = ["手动", "自动"];
            let msg = arr[item.publishType];
            return h("div", msg || "-");
          },
        },

        {
          title: "状态",
          key: "gmtCreate",

          render: (h, params) => {
            const item = params.row;
            let arr = ["待上线", "已上线", "已下线"];
            let msg = arr[item.status];
            return h("div", msg || "-");
          },
        },
        {
          title: "创建时间",

          key: "gmtCreate",

          render: (h, params) => {
            const item = params.row;
            return h("div", item.gmtCreate || "-");
          },
        },
        {
          title: "上线时间",
          key: "effectiveTime",

          render: (h, params) => {
            const item = params.row;
            return h("div", item.effectiveTime || "-");
          },
        },
        {
          title: "下线时间",
          key: "failureTime",

          render: (h, params) => {
            const item = params.row;
            return h("div", item.failureTime || "-");
          },
        },
        //  {
        //   title: "下线时间",
        //   key: "failureTime",
        //   render: (h, params) => {
        //     const item = params.row;
        //     return h("div", item.failureTime || "-");
        // },
        {
          title: "操作",
          key: "address",
          align: "left",
          width: 250,
          className: "action",
          render: (h, params) => {
            let item = params.row;
            let btn = [];
            if (item.status == "0") {
              btn = [
                h(
                  "span",
                  {
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#ed4014"
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.notpublic(params.row);
                      },
                    },
                  },
                  item.status == 0 ? "上线" : "下线"
                ),
                h(
                  "span",
                  {
                    style: {
                      color: "#ddd",
                      margin: "0 10px",
                      verticalAlign: "middle",
                      display: item.status == 0 ? "initial" : "none",
                    },
                  },
                  "|"
                ),
                h(
                  "span",
                  {
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#ed4014"
                      cursor: "pointer",
                      display: item.status == 0 ? "initial" : "none",
                    },
                    on: {
                      click: () => {
                        this.edit(params.row);
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "span",
                  {
                    style: {
                      color: "#ddd",
                      margin: "0 10px",
                      verticalAlign: "middle",
                      display: item.status == 0 ? "initial" : "none",
                    },
                  },
                  "|"
                ),
                h(
                  "span",
                  {
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#ed4014"
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.delNotice(params.row);
                      },
                    },
                  },
                  "删除"
                ),
              ];
            } else if (item.status == "1") {
              btn = [
                h(
                  "span",
                  {
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#ed4014"
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.notpublic(params.row);
                      },
                    },
                  },
                  item.status == 0 ? "上线" : "下线"
                ),
              ];
            } else {
              btn = [
                h(
                  "span",
                  {
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#ed4014"
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.delNotice(params.row);
                      },
                    },
                  },
                  "删除"
                ),
              ];
            }
            btn.push(
              h(
                "span",
                {
                  style: {
                    color: "#ddd",
                    margin: "0 10px",
                    verticalAlign: "middle",
            
                  },
                },
                "|"
              ),
              h(
                "span",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    color: "#0c479d", //"#ed4014"
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.lookNews(params.row);
                    },
                  },
                },
                "查看"
              )
            );
            return h("div", btn);
          },
        },
      ],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.cdataColumn = this.dataColumn;
      this.getLists();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getLists();
      }, 1000 * 60);
      this.$store.state.spinShow = false;
    },
    notTopping(row) {
      let stats = row.status;
      let title = "是否要置顶该公告？";
      if (row.sort > 0) {
        title = "是否要取消置顶该公告？";
      }
      this.$Modal.confirm({
        title,
        content: `公告标题：${row.title}`,
        onCancel: () => {},
        onOk: async () => {
          notptoptop({ id: row.id }).then((res) => {
            if (res.code === "00000") {
              this.$Message.success("修改成功");
              this.curItemDetail = {};
              const finalSize = this.sizeData(
                this.pageInfo.size,
                this.pageInfo.current,
                this.pageInfo.total
              );
              this.getLists(finalSize);
            }
          });
        },
      });
    },
    notpublic(row) {
      let stats = row.status;
      let title = "是否要发布该公告？";
      if (row.status == 1) {
        title = "是否要下线该公告？";
      }
      this.$Modal.confirm({
        title,
        content: `公告标题：${row.title}`,
        onCancel: () => {},
        onOk: async () => {
          notpublish({ id: row.id }).then((res) => {
            if (res.code === "00000") {
              this.$Message.success("修改成功");
              this.curItemDetail = {};
              const finalSize = this.sizeData(
                this.pageInfo.size,
                this.pageInfo.current,
                this.pageInfo.total
              );
              this.getLists(finalSize);
            }
          });
        },
      });
    },
    edit(row) {
      this.propForm = this.$c.deepClone(row);
      console.log(" this.propForm222 ", this.propForm, row);
      this.showlistDrawer = true;
    },
    async getLists(page) {
      // this.$store.state.spinShow = true;
      if (page) this.pageInfo.current = page; //分页处理
      let data = await notelist({
        ...this.pageInfo,
        ...this.dataForm,
      });

      if (data.code === "00000") {
        const datas = data.data;
        this.dataLists = datas.records;
        this.pageInfo.total = datas.total;
      }

      // api.axss("post", "/ocm-admin/notice/listPage", {
      //     ...this.pageInfo,
      //     ...this.dataForm,
      // }).then((res) => {
      //     if (res.code === "00000") {

      //     }
      // });
    },
    changeSize(data) {
      this.pageInfo.size = data;
      this.getLists();
    },
    searchInput(val, name) {
      this.selItems = this.handleSelItem(val, name);
      this.getLists(1);
    },
    changeSel(val, name) {
      this.selItems = this.handleSelItem(val, name);
      this.getLists(1);
    },
    changeDate(date, name) {
      // gmtCreateDateStart
      // gmtCreateDateStart
      if (name === "date") {
        this.dataForm.gmtCreateDateStart = date[0];
        this.dataForm.gmtCreateDateEnd = date[1];
        this.selItems = this.handleSelItem(date[0] + "至" + date[1], name);
      }
      if (name === "dates") {
        //  effectiveStartTime
        this.dataForm.effectiveStartTime = date[0];
        this.dataForm.effectiveEndTime = date[1];
        this.selItems = this.handleSelItem(date[0] + "至" + date[1], name);
      }
      this.getLists(1);
    },
    delSelItem(selItem, index) {
      console.log("selItem", selItem);
      // gmtCreateDateStart
      this.dataForm[selItem.name] = null;
      //日期需要单独处理
      if (selItem.name === "dates") {
        delete this.dataForm.effectiveStartTime;
        delete this.dataForm.effectiveEndTime;
      }
      if (selItem.name === "date") {
        console.log("1111111111111");
        delete this.dataForm.gmtCreateDateStart;
        delete this.dataForm.gmtCreateDateEnd;
      }
      this.selItems.splice(index, 1);
      this.getLists(1);
    },
    addNotice() {
      this.propForm = {};
      this.showlistDrawer = true;
    },
      async lookNews(data) {
      
      if(data.messageStatus=="notice"){
        this.curItemDetail.title=data.title
      }else{
         this.curItemDetail.title="消息"
      }
     
      data.messageStatus="read"
       data.messageContent=data.content
       this.curItemDetail = this.$c.deepClone(data);
      this.ismodel = true;
      this.$emit("on-open-modal");
    },
    delNotice(item) {
      this.curItemDetail = deepcopy(item);
      this.$Modal.confirm({
        title: "您确定要删除该公告吗？",
        content: `公告标题：${item.title}`,
        onCancel: () => {},
        onOk: () => {
          this.delItem();
        },
      });
    },
    delItem() {
      api
        .axss("get", `/ocm-admin/notice/del/${this.curItemDetail.id}`)
        .then((res) => {
          if (res.code === "00000") {
            this.$Message.success("删除成功");
            this.curItemDetail = {};
            const finalSize = this.sizeData(
              this.pageInfo.size,
              this.pageInfo.current,
              this.pageInfo.total
            );
            this.getLists(finalSize);
          }
        });
    },
    closeDrawer() {
      this.showlistDrawer = false;
      this.curItemDetail = {};
    },
    resetData() {
      this.reset("dataForm");
      this.getLists(1);
    },
    reset(key) {
      this.selItems = [];
      Object.keys(this[key]).forEach((item) => {
        this[key][item] = "";
      });
    },
  },
};
</script>

<style lang='less' scoped>
.system-notice {
}
</style>